import { createFeatureSelector, createSelector, select } from '@ngrx/store';
import { ComponentsState } from '../reducers/component.reducer';
import { StateProperty } from '../reducers';
import { pipe } from 'rxjs';
import { filterNonNull } from '@utils/rxjs.utils';

export const componentsSelector = createFeatureSelector<ComponentsState>(StateProperty.COMPONENTS);

export const selectMenuVisible = createSelector(
  componentsSelector,
  (state: ComponentsState): boolean => state.menu.visible
);

export const isMenuVisible = pipe(
  select(selectMenuVisible),
  filterNonNull<boolean>
)
